import { render, staticRenderFns } from "./FormMultipleChoicesConfig.vue?vue&type=template&id=0b6b3eab&scoped=true"
import script from "./FormMultipleChoicesConfig.vue?vue&type=script&lang=js"
export * from "./FormMultipleChoicesConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b6b3eab",
  null
  
)

export default component.exports